export interface PDFDocumentFile {
  id: string;
  name: string;
  file: File;
  url: string;
  uploadedAt: Date;
  numPages?: number;
}

export interface PDFViewerState {
  currentPage: number;
  numPages: number;
  scale: number;
  rotation: number;
  position: { x: number; y: number };
}

export const DEFAULT_SCALE = 1;
export const MIN_SCALE = 0.1;
export const MAX_SCALE = 20;
export const SCALE_STEP = 0.25;
